import { Trans } from "react-i18next";

import util from "utils/utils";

import FormattedComment from "components/lib/FormattedComment";

import type { NotificationContentProps } from "../../types";

export default function ActivityFeedPosted({
  events = [],
  ownerGroup,
}: NotificationContentProps) {
  const namedEvents = (events ?? []).filter(
    (event) => event.user && !event.isAnonymous,
  );
  const messages = (events ?? [])
    .map((event) => event.message)
    .filter(Boolean)
    .map((message) => `"${message}"`)
    .join(", ");
  const groupName = ownerGroup?.name || "Deleted";

  if (namedEvents.length > 0) {
    return (
      <Trans
        i18nKey={
          messages
            ? "notifications.groupActivityFeedPosted"
            : "notifications.groupActivityFeedPostedNoMessage"
        }
        values={{
          name: util.getEventNames(namedEvents),
          group: groupName,
          message: messages,
        }}
        components={{
          b: <b />,
          formattedComment: <FormattedComment noLink maxLength={100} />,
        }}
      />
    );
  }

  return (
    <Trans
      i18nKey={
        messages
          ? "notifications.groupActivityFeedPostedAnonymous"
          : "notifications.groupActivityFeedPostedAnonymousNoMessage"
      }
      values={{ group: groupName, message: messages }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink maxLength={100} />,
      }}
    />
  );
}
